import { styled } from 'styled-components';

import { device, typography } from '@/styles/helpers';

export const ScLoyaltySection = styled.div<{ showFullInfo?: boolean }>`
  display: flex;
  flex-direction: column;
  gap: 12px;

  .info {
    display: flex;
    flex-direction: column;
    ${typography['body1regular']}
    letter-spacing: 0.16px;

    span b {
      margin-right: 8px;
    }

    .level-info {
      display: flex;
      align-items: center;
      gap: 8px;

      .text {
        width: 100%;
        display: flex;
        flex-direction: column;
      }

      & > .addons {
        display: flex;
        align-items: center;

        @media (${device.mobileS}) {
          gap: 4px;
        }

        & > img {
          flex-shrink: 0;
        }

        & > svg {
          flex-shrink: 0;
          transform: rotate(
            ${({ showFullInfo }) => (showFullInfo ? '180deg' : '0deg')}
          );
          transition: stroke 0.3s ease;

          path {
            stroke: ${({ theme, showFullInfo }) =>
              showFullInfo ? theme.whiteColor : theme.blackLightColor};
          }
        }
      }
    }
  }

  & > .footer {
    display: grid;
    grid-template-columns: repeat(2, 1fr);
    gap: 8px;
  }
`;
